import { query } from '@confluence/query-preloader-tools';
/* eslint-disable-next-line import/no-extraneous-dependencies */
import { preloadCreateSpace } from '@confluence/create-space/entry-points/preloadCreateSpace';

import {
	StarredSpacesQuery,
	MyVisitedSpacesQuery,
	MyVisitedSpacesWithCurrentSpaceQuery,
	AnonymousSpacesQuery,
} from './SpacesListQueries.graphql';

type preloadSpacesListOptions = {
	isLicensed: boolean;
	selectedSpaceKey?: string;
};

export const preloadSpacesList = ({
	isLicensed,
	selectedSpaceKey,
}: preloadSpacesListOptions): Promise<{ data: unknown }> => {
	const preloadQueries: Promise<{ data: unknown }>[] = [];

	if (isLicensed) {
		preloadQueries.push(
			query({
				query: StarredSpacesQuery,
				variables: {},
			}),
		);
		if (selectedSpaceKey) {
			preloadQueries.push(
				query({
					query: MyVisitedSpacesWithCurrentSpaceQuery,
					variables: { selectedSpaceKey },
				}),
			);
		} else {
			preloadQueries.push(
				query({
					query: MyVisitedSpacesQuery,
					variables: {},
				}),
			);
		}
	} else {
		preloadQueries.push(
			query({
				query: AnonymousSpacesQuery,
				variables: {},
			}),
		);
	}

	preloadQueries.push(preloadCreateSpace({ isLicensed }));

	return Promise.all(preloadQueries).then(() => ({ data: {} }));
};
